import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { UserSessionService } from 'src/app/services/usersession.service';

@Injectable()
export class AuthGuard  {

  constructor(
    private router: Router,
    private userSessionService: UserSessionService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let menuItems = [];
    const paths = [];
    const menu = this.userSessionService.getLocalStorageWithKey('menu');
    if (menu) {
      menuItems = JSON.parse(menu);
    }
    if (localStorage.getItem('isLoggedin')) {
      if (state.url === '/dashboard') return true;
      if (menuItems && menuItems.length > 0 && localStorage.getItem('isLoggedin')) {
        menuItems.forEach(field => {
          if (field.link || this.isBusInformationMenu(field.label)) { paths.push(this.normalizeMenuLink(field.label, field.link)); }
          if (field.subItems && field.subItems.length > 0) {
            field.subItems.forEach(sm => {
              if (sm.link || this.isBusInformationMenu(sm.label)) {
                paths.push(this.normalizeMenuLink(sm.label, sm.link));
              }
            });
          }
        });
        if (paths.indexOf(state.url) >= 0) {
          return true;
        } else {
          const urls = state.url.split('/');
          if (urls.length > 1 && paths.indexOf('/' + urls[1]) >= 0) {
            return true;
          }
        }
      }
    } else {
      this.router.navigate(['/auth']);
    }
    this.router.navigate(['/auth']);
    // this.router.navigate(['/auth'], { queryParams: { returnUrl: state.url } });
    return true;
  }

  private normalizeMenuLink(label: string, link: string): string {
    if (this.isBusInformationMenu(label)) {
      return '/BusSchedule';
    }

    if (!link) {
      return link;
    }

    return link.startsWith('/') ? link : `/${link}`;
  }

  private isBusInformationMenu(label: string): boolean {
    return (label || '').trim().toLowerCase() === 'bus information';
  }
}
